import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const Logo = ({ size = 40, showText = true, light = false }) => {
  const { t } = useTranslation();
  const textColor = light ? '#ffffff' : '#0f2a5e';
  const subTextColor = light ? 'rgba(255,255,255,0.7)' : '#1e8a4c';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
      {/* Shield + Camera Icon */}
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Shield */}
        <path
          d="M24 4L6 12V24C6 33.9 14.1 43.2 24 46C33.9 43.2 42 33.9 42 24V12L24 4Z"
          fill="#0f2a5e"
        />
        {/* Inner shield highlight */}
        <path
          d="M24 8L10 15V24C10 31.8 16.3 39.2 24 42C31.7 39.2 38 31.8 38 24V15L24 8Z"
          fill="#1a3a7a"
        />
        {/* Camera body */}
        <rect x="13" y="18" width="14" height="10" rx="2" fill="white" />
        {/* Camera lens */}
        <circle cx="20" cy="23" r="3" fill="#0f2a5e" />
        <circle cx="20" cy="23" r="1.5" fill="#1e8a4c" />
        {/* Camera viewfinder */}
        <path d="M27 20.5L31 18.5V27.5L27 25.5" fill="white" />
        {/* OM symbol / decorative dot top */}
        <circle cx="24" cy="11" r="2" fill="#f97316" />
        {/* Green accent bottom */}
        <path d="M16 34C18.5 35.5 21 36.2 24 36.5C27 36.2 29.5 35.5 32 34" stroke="#1e8a4c" strokeWidth="2" strokeLinecap="round" />
      </svg>

      {showText && (
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
          <span style={{
            fontFamily: "'Fraunces', serif",
            fontWeight: 900,
            fontSize: size * 0.42,
            color: textColor,
            letterSpacing: '-0.01em'
          }}>
            {t('common.companyName')}
          </span>
          <span style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 700,
            fontSize: size * 0.22,
            color: subTextColor,
            letterSpacing: '0.06em',
            textTransform: 'uppercase'
          }}>
            Enterprises
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
